import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Forces scroll to the top on every route change.
 * Also supports #hash targets and custom scroll containers.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  // Always disable the browser's automatic scroll restoration
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    // If there's a hash, scroll to that element after paint
    if (hash) {
      requestAnimationFrame(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        }
      });
      return;
    }

    // No hash → hard reset scroll to top.
    // Do it a few frames in a row to beat late layout shifts.
    let frame = 0;
    const maxFrames = 3;
    const tick = () => {
      // Window scroll roots
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      // Any custom scroll containers (opt-in with data-scroll-root)
      document
        .querySelectorAll("[data-scroll-root]")
        .forEach((n) => (n.scrollTop = 0));

      if (++frame < maxFrames) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [pathname, hash]);

  return null;
}
